<template>
  <div v-if="faqContent && roleId">
    <div class="faq" :class="{ isLogin: isLogin }" @click="showFaq"></div>
    <PopupWindow
      v-if="visibleFaq"
      :languages="letter"
      title="FAQ"
      :content="faqContent"
      type="tips"
      textAlign="left"
      @onConfirm="visibleFaq = false"
      @onCancel="visibleFaq = false"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { clickButton } from '@plugins/biPoint/_configWebstoreV35';
export default {
  name: 'Faq',
  data() {
    return {
      visibleFaq: false
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      faqLangJson: state => state.page.faqLangJson,
      isLogin: state => state.login.isLogin,
      roleId: state => state.roleId
    }),
    faqContent() {
      return this.faqLangJson?.[this.lang]?.content || '';
    }
  },
  methods: {
    showFaq() {
      this.visibleFaq = true;
      clickButton({
        btnName: 'faq',
        locationKey: this.$route.meta.pageName
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.faq {
  overflow: hidden;
  z-index: 21;
  position: fixed;
  bottom: 540px;
  right: 10px;
  width: 70px;
  height: 70px;
  background: url($commonImg + 'm-faq.png') no-repeat center/contain;
  background-color: #ffffff;
  border-radius: 50%;
  cursor: pointer;

  &.isLogin {
    bottom: 340px;
  }
}

::v-deep .tips-content {
  white-space: pre-wrap;
}

#ssr-page.landscape {
  .faq,
  .faq.isLogin {
    right: 40px;
    bottom: 120px;
  }
}
</style>
